import React from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
    const location = useLocation();
    return (
        <div id="scrollbar">
            <div className="container-fluid">
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                    <li className="menu-title">
                        <span data-key="t-menu">Menu</span>
                    </li>
                    <li className="nav-item">
                        <Link
                            className="nav-link menu-link"
                            to={'/admin/dashboard'}
                           
                            role="button"
                            aria-expanded="false"
                            aria-controls="sidebarDashboards"
                        >
                            <i className="ri-dashboard-2-line" />{" "}
                            <span data-key="t-dashboards">Dashboards</span>
                        </Link>
                    </li>{" "}
                    {/* end Dashboard Menu */}
                    <li className="nav-item">
                        <a
                            className="nav-link menu-link"
                            href="#sidebarApps"
                            data-bs-toggle="collapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="sidebarApps"
                        >
                            <i className="ri-apps-2-line" />{" "}
                            <span data-key="t-apps">Companies</span>
                        </a>
                        <div className="collapse menu-dropdown" id="sidebarApps">
                            <ul className="nav nav-sm flex-column">
                                
                                <li className="nav-item">
                                    <Link
                                        to={'/admin/companies/add'}
                                        className="nav-link"
                                        data-key="t-chat"
                                    >
                                       
                                        Add New
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={'/admin/companies'}
                                        className="nav-link"
                                        data-key="t-chat"
                                    >
                                       
                                        All Companies 
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={'/admin/companies?status=pending'}
                                        className="nav-link"
                                        data-key="t-chat"
                                    >
                                       
                                        Pending Companies
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={'/admin/companies?status=approved'}
                                        className="nav-link"
                                        data-key="t-chat"
                                    >
                                       
                                        Approved Companies
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link menu-link"
                            href="#roles"
                            data-bs-toggle="collapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="sidebarApps"
                        >
                            <i className="ri-apps-2-line" />{" "}
                            <span data-key="t-apps">Roles & Permissions</span>
                        </a>
                        <div className="collapse menu-dropdown" id="roles">
                            <ul className="nav nav-sm flex-column">
                                
                               
                                <li className="nav-item">
                                    <Link
                                       to={'/admin/roles'}
                                        className="nav-link"
                                        data-key="t-chat"
                                    >
                                       
                                        Roles 
                                    </Link>
                                </li>
                                
                            </ul>
                        </div>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link menu-link"
                            href="#staff"
                            data-bs-toggle="collapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="sidebarApps"
                        >
                            <i className="ri-apps-2-line" />{" "}
                            <span data-key="t-apps">Staff Management</span>
                        </a>
                        <div className="collapse menu-dropdown" id="staff">
                            <ul className="nav nav-sm flex-column">
                                
                                <li className="nav-item">
                                    <Link
                                        to={'/admin/staff/add'}
                                        className="nav-link"
                                        data-key="t-chat"
                                    >
                                       
                                        Add New
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={'/admin/staff'}
                                        className="nav-link"
                                        data-key="t-chat"
                                    >
                                       
                                        All Staff 
                                    </Link>
                                </li>
                                
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
            {/* Sidebar */}
        </div>
    );
}

export default Sidebar;